import React from 'react';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';

const EmbedIframe = ({ input }) => {
  //console.log(input.primary.link);

  const {
    embed_url,
    ///, title, url
  } = input.primary.link;

  return (
    <Iframe
      url={embed_url}
      width="100%"
      height="960px"
      id={input.primary.id}
      className="myClassname"
      display="initial"
      position="relative"
    />
  );
};

export default EmbedIframe;

EmbedIframe.propTypes = {
  input: PropTypes.object.isRequired,
};
